<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <div class="row">
            <div class="contact-form col-lg-6">
              <div v-if="validationErrors">
                <ul class="alert alert-danger" style="list-style: none;">
                  <li
                    v-for="(value, key, index) in validationErrors"
                    v-bind:key="index"
                  >
                    {{ value[0] }}
                  </li>
                </ul>
              </div>

              <form id="contact" @submit="checkForm" action="#" method="post">
                <input type="hidden" v-model="formData.type" />

                <div v-if="errors.length" class="alert alert-warning">
                  <b>Please correct the following error(s):</b>
                  <ul>
                    <li v-for="(error, index) in errors" v-bind:key="index">
                      {{ error[0] }}
                    </li>
                  </ul>
                </div>

                <div class="form-group">
                  <label for="exampleInputName"
                    >{{ nameType }} নাম<span class="required">*</span></label
                  >
                  <input
                    autocomplete="off"
                    type="text"
                    class="form-control"
                    id="exampleInputName"
                    name="name"
                    v-model="formData.name"
                    :placeholder="` আপনার ${nameType ? nameType : ''}নাম লিখুন`"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputPhone"
                    >মোবাইল নাম্বার<span class="required">*</span></label
                  >
                  <input
                    autocomplete="off"
                    type="number"
                    class="form-control"
                    name="phone"
                    id="exampleInputPhone"
                    v-model="formData.mobile"
                    placeholder=" আপনার মোবাইল নাম্বার এখানে দিন"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">ইমেইল</label>
                  <input
                    autocomplete="off"
                    type="email"
                    class="form-control"
                    id="exampleInputEmail1"
                    name="email"
                    v-model="formData.email"
                    aria-describedby="emailHelp"
                    placeholder=" আপনার ইমেইল এখানে লিখুন"
                  />
                  <small id="emailHelp" class="form-text text-muted">
                    আমরা আপনার ইমেইল কারো সাথে শেয়ার করব না</small
                  >
                </div>

                <div class="form-group">
                  <label for="exampleInputMessage"
                    >পাসওয়ার্ড<span class="required">*</span></label
                  >
                  <input
                    autocomplete="off"
                    class="form-control"
                    type="password"
                    name="password"
                    id="exampleInputMessage"
                    v-model="formData.password"
                    placeholder="আপনার পাসওয়ার্ড এখানে লিখুন"
                  />
                </div>

                <button type="submit" class="btn btn-primary">
                  নিবন্ধন করুন
                </button>
              </form>
              <div class="mt-2">
                <router-link :to="{ name: 'login' }">লগইন করুন! </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import Layout from "../layouts/Layout";

export default {
  name: `Home`,
  components: {
    Layout
  },
  data() {
    return {
      errors: [],
      validationErrors: null,
      nameType: "",
      formData: {
        name: null,
        email: null,
        mobile: null,
        password: null,
        redirectUrl: null,
        type: ""
      }
    };
  },
  mounted() {
    this.formData.type = this.$route.query.type;
    if (this.$route.query.type == "merchant") {
      this.nameType = "কোম্পানির ";
    }
  },
  methods: {
    checkForm: function(e) {
      e.preventDefault();

      if (!this.formData.name) {
        this.flashMessage.error({ message: "আপনার নাম লিখুন" });
        return false;
      }

      if (!this.formData.mobile || this.formData.mobile.length != 11) {
        this.flashMessage.error({ message: "আপনার মোবাইল নাম্বার লিখুন" });
        return false;
      }

      if (!this.formData.password) {
        this.flashMessage.error({ message: "আপনার পাসওয়ার্ড লিখুন" });
        return false;
      }

      this.$http
        .post("signup", this.formData)
        .then(response => {
          if (response.data.status) {
            if (this.formData.type == "merchant") {
                this.formData.name = '';
                this.formData.email = '';
                this.formData.mobile = '';
                this.formData.password = '';
                this.flashMessage.success({
                  message:
                    "Congratulations! Your account has been created successfully. We will contact you shortly."
                });
            } else {
              localStorage.setItem("token", response.data.token);
              localStorage.setItem("user_id", response.data.user.id);
              localStorage.setItem("name", response.data.user.name);
              localStorage.setItem("mobile", response.data.user.mobile);
              localStorage.setItem("email", response.data.user.email);

              this.flashMessage.success({
                message:
                  "Congratulations! Your account has been created successfully."
              });
              if (this.redirectUrl) {
                location.href = this.redirectUrl;
              } else {
                location.href = "customer/dashboard/profile";
              }
            }
          } else {
            this.flashMessage.error({
              message: response.data.message
            });
          }
        })
        .catch(error => {
          if (error.response.status == 422) {
            console.log(error.response.data.errors);
            this.validationErrors = error.response.data.errors || {};
          }
        });
    }
  }
};
</script>
